// Téléphone d'un travailleur ou d'un membre de sa famille, saisi avec le drapeau défini dans les paramètres de
// l'établissement et enregistré « +indicatif numéro » (04/10/2026).

export function separerTelephone(complet) {
	const texte = String(complet || '').trim()
	const morceaux = /^(\+\d{1,4})\s+(.+)$/.exec(texte)
	return morceaux ? { indicatif: morceaux[1], numero: morceaux[2] } : { indicatif: '', numero: texte }
}

export function assemblerTelephone(indicatif, numero) {
	const n = String(numero || '').trim()
	if (!n) return ''
	if (n.charAt(0) === '+') return n
	return indicatif ? indicatif + ' ' + n : n
}
